<template>
  <div class="p-16">
    <SectionOrder
      :product="product"
      :package-items="packageItems"
      :package-editions="packageEditions"
    />
  </div>
</template>

<script>
import SectionOrder from './single/SectionOrder.vue';

export default {
  name: 'ProductSingle',
  components: {
    SectionOrder,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    packageItems: {
      type: Array,
      default: () => [],
    },
    packageEditions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
